import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Row from '../../shared/components/Row';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { I18nUtils } from '../../../i18n/I18nUtils';
import FormField from '../../shared/components/FormField';
import Card from '../../shared/components/Card';
import CardSimpleHeader from '../../shared/components/CardSimpleHeader';
import CardBody from '../../shared/components/CardBody';
import * as userActions from '../actions/userActions';
import * as contractorsActions from '../../contractors/actions/contractorsActions';
import { bindActionCreators } from 'redux';
import { isEmailValid } from '../../shared/utils/StringUtils';
import UserRole from '../../shared/model/UserRole';
import UserAdminCopyCompaniesModal from './UserAdminCopyCompaniesModal';
import FormAutocomplete from '../../shared/components/FormAutocomplete';
import { OPTIONS } from '../../shared/utils/OptionsManager';
import { CurrentUser } from '../../shared/model/CurrentUser';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

const FORM = {
    NAME: 'UserForm',
    FIELDS: {
        CONTRACTOR_ID: 'contractor_id',
        COMPANY_IDS: 'company_ids',
        CONTRACTOR_ROLE_FIELDS: {
            SELECTOR_COMPANY_TYPE: 'selectorCompanyType',
            SELECTED_COMPANY: 'selectedCompany',
        },
        NAME: 'name',
        LAST_NAME: 'last_name',
        EMAIL: 'email',
        PASSWORD: 'password',
        ROLE_ID: 'role_id',
        ENABLED: 'enabled',
        SUBMIT: 'submit',
    },
};

const COMPANY_TYPE_CURRENT_CONTRACTOR = 0;
const COMPANY_TYPE_OUTSOURCE = 1;

class UserFormCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            adminCompanies: [],
            showCopyCompaniesModal: null,
            showCompanyAutocomplete: false,
        };
    }

    componentDidMount() {
        const { initialValues, change, currentUser } = this.props;

        if ( initialValues && initialValues.roles ) {
            this.setState({
                adminCompanies: initialValues
                    .roles
                    .filter((role) => role.company !== null)
                    .filter((role) => role.company.id !== currentUser.myCompanyId())
                    .map((role) => ( {
                        id: role.company ? role.company.id : -1,
                        name: role.company ? role.company.name : '',
                    } )),
            });
        }

        if ( initialValues && initialValues.contractor ) {
            change(FORM.FIELDS.CONTRACTOR_ID, [{
                item: initialValues.contractor,
                label: initialValues.contractor.name,
                value: initialValues.contractor.id,
            }]);
        }

        // Inicializar campos para escoger contrata en caso de que el rol del usuario sea contractor
        if ( initialValues && Number(initialValues.selectorCompanyType) ) {
            change(FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTOR_COMPANY_TYPE, initialValues.selectorCompanyType);
            this.setState({ showCompanyAutocomplete: !!initialValues.selectorCompanyType });
        }
    }

    componentWillUpdate(nextProps, state) {
        // Inicializar adminCompanies:
        if ( ( nextProps.initialValues !== this.props.initialValues ) && !this.props.initialValues ) {
            if ( ( nextProps.initialValues.role_id === UserRole.OUTSOURCES_MANAGER ) ||
                nextProps.initialValues.role_id === UserRole.CONTRACTORS_MANAGER ) {
                this.setState({
                    adminCompanies: !nextProps.initialValues || !nextProps.initialValues.roles
                        ? []
                        : nextProps
                            .initialValues
                            .roles
                            .filter((role) => role.company !== null)
                            .filter((role) => role.company.id !== this.props.currentUser.myCompanyId())
                            .map((role) => ( {
                                id: role.company ? role.company.id : -1,
                                name: role.company ? role.company.name : '',
                            } )),
                });
            }

            if ( nextProps.initialValues && nextProps.initialValues.contractor ) {
                this.props.change(FORM.FIELDS.CONTRACTOR_ID, [{
                    item: nextProps.initialValues.contractor,
                    label: nextProps.initialValues.contractor.name,
                    value: nextProps.initialValues.contractor.id,
                }]);
            }
        }
    }

    componentWillMount() {
        this.props.userActions.getUserRoles();
    }

    componentWillUnmount() {
        this.props.contractorsActions.clearContractors();
    }

    handleChangeAdminCompany = (index, company) => {
        let newAdminCompanies = this.state.adminCompanies;
        if ( !newAdminCompanies ) {
            newAdminCompanies = [];
        }
        if ( company === null ) {
            newAdminCompanies.splice(index, 1);
        } else {
            newAdminCompanies[index] = company;
        }
        this.setState({ adminCompanies: newAdminCompanies });
    };

    renderField = (field) => <FormField field={field}/>;

    renderCompanies(
        {
            fields,
            adminCompanies,
            onChangeAdminCompany,
            meta: { error },
            companies,
            openCopyCompanies,
            formValues,
        },
    ) {
        const companiesError =
            formValues &&
            formValues.syncErrors &&
            formValues.syncErrors[FORM.FIELDS.COMPANY_IDS] &&
            formValues.syncErrors[FORM.FIELDS.COMPANY_IDS].length !== 0 ?
                formValues.syncErrors[FORM.FIELDS.COMPANY_IDS] : '';

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <label>{I18nUtils.tr('TR_GESTIONA_A') + ':'}</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-7"/>
                    <div className="col-xs-4 text-right">
                        <button
                            type="button"
                            className="btn btn-default"
                            onClick={openCopyCompanies}
                            children={I18nUtils.tr('TR_IMPORTAR')}
                        />
                    </div>
                    <div className="col-xs-1">
                        <a onClick={() => {
                            fields.unshift({});
                            adminCompanies.unshift(null);
                        }}>
                            <span className="badge pull-right">
                                <i className="material-icons">add</i>
                            </span>
                        </a>
                    </div>
                </div>
                {
                    fields.map((member, index) => {
                        return (
                            <Row key={index}>
                                <Field
                                    name={`${member}`}
                                    component={(field) => <FormField field={field}/>}
                                    label={''}
                                    type={'selectCompanyAutocomplete'}
                                    options={companies}
                                    onlyActive={true}
                                    colWidth="col-md-11"
                                    company={adminCompanies && adminCompanies[index] ? adminCompanies[index] : null}
                                    onChangeCompany={(company) => {
                                        onChangeAdminCompany(index, company);
                                    }}
                                />
                                <div className="col-xs-1 ">
                                    <a onClick={() => {
                                        fields.remove(index);
                                        onChangeAdminCompany(index, null);
                                    }}>
                                    <span className="badge pull-right m-t-10">
                                        <i className="material-icons">clear</i>
                                    </span>
                                    </a>
                                </div>
                            </Row>
                        );
                    })
                }
                <Row>
                    <div className="col-xs-12">
                        <div className="form-group">
                            <label className="error">{companiesError || error}</label>
                        </div>
                    </div>
                </Row>
            </div>
        );
    }

    renderCurrentContractorFieldName() {
        const {
            userContractorName,
            currentUser,
            user,
        } = this.props;

        const name = !user ? currentUser.contractor().name : userContractorName;

        return (
            <div className={'col-md-6'}>
                <div className={'form-group'}>
                    <label>{I18nUtils.tr('TR_PERTENECE_A') + ':'}</label>
                    <div className="row">
                        <div className="col-xs-10">
                            <input
                                type={'text'}
                                className={'form-control'}
                                value={name}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCompanyOrCompanies() {
        const {
            contractors,
            contractorsLoading,
            currentUser,
            isCurrentUser,
            roleSelected,
            formValues,
        } = this.props;

        var disabled = isCurrentUser;

        switch ( roleSelected ) {
            case String(UserRole.OUTSOURCES_MANAGER):
                return (
                    <div className="col-md-6">
                        <FieldArray
                            name={FORM.FIELDS.COMPANY_IDS}
                            component={this.renderCompanies}
                            adminCompanies={this.state.adminCompanies}
                            onChangeAdminCompany={this.handleChangeAdminCompany}
                            openCopyCompanies={() => this.setState({ showCopyCompaniesModal: true })}
                            disabled={disabled}
                            formValues={formValues}
                        />
                    </div>
                );
            case String(UserRole.ADMIN):
                if ( currentUser.role() === UserRole.ADMIN ) {
                    const contractor = currentUser.contractor();
                    if ( contractor ) {
                        this.props.change(FORM.FIELDS.CONTRACTOR_ID, [{
                            item: contractor,
                            label: contractor.name,
                            value: contractor.id,
                        }]);
                    }
                }
                if ( currentUser.role() === UserRole.SUPERADMIN ) {
                    return (
                        <Field
                            col="col-md-6"
                            name={FORM.FIELDS.CONTRACTOR_ID}
                            label={I18nUtils.tr('TR_CONTRATISTA') + ':'}
                            placeholder={I18nUtils.tr('TR_EMPRESA_CONTRATISTA')}
                            loading={contractorsLoading}
                            options={OPTIONS.contractors(contractors)}
                            component={FormAutocomplete}
                            onSearch={this.searchContractors}
                            onSelected={this.handleSelectContractor}
                            disabled={disabled}
                        />
                    );
                }
                break;
            case String(UserRole.CONTRACTORS_MANAGER):
            case String(UserRole.OUTSOURCES_VIEWER):
            default:
                return null;
        }
    }

    renderRadioGroup(
        {
            col,
            input,
            ...rest
        },
    ) {
        return (
            <div className={col}>
                <RadioButtonGroup
                    {...input}
                    {...rest}
                    valueSelected={input.value}
                    onChange={(event, value) => {
                        input.onChange(value);
                    }}
                />
            </div>
        );
    }

    renderSelectorCompanyToManage() {
        const {
            userContractorName,
            currentUser,
            user,
            initialValues,
        } = this.props;
        const {
            showCompanyAutocomplete,
        } = this.state;

        const contractorName = !user ? currentUser.contractor().name : userContractorName;
        const iconStyle = { fill: 'gray', marginRight: '5px' };
        return (
            <React.Fragment>
                <Field
                    col={'col-md-6'}
                    name={FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTOR_COMPANY_TYPE}
                    component={this.renderRadioGroup}
                    onChange={this.handleOnChangeSelectorCompanyToManageOption}
                >
                    <RadioButton
                        value={COMPANY_TYPE_CURRENT_CONTRACTOR}
                        label={`${I18nUtils.tr('TR_PERTENECE_A_MI_EMPRESA')}: ${contractorName}`}
                        iconStyle={iconStyle}
                    />
                    <RadioButton
                        value={COMPANY_TYPE_OUTSOURCE}
                        label={`${I18nUtils.tr('TR_PERTENECE_A_LA_SUBCONTRATA')}:`}
                        iconStyle={iconStyle}
                    />
                </Field>
                {
                    showCompanyAutocomplete &&
                    <Field
                        name={FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTED_COMPANY}
                        type={'selectCompanyAutocomplete'}
                        colWidth="col-md-6"
                        component={this.renderField}
                        company={initialValues.selectedCompany}
                    />
                }
            </React.Fragment>
        );
    }

    handleOnChangeSelectorCompanyToManageOption = (event, value) => {
        const { currentUser, change } = this.props;

        change(FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTED_COMPANY,
            value === COMPANY_TYPE_CURRENT_CONTRACTOR ? currentUser.company().id : null);
        this.setState({
            showCompanyAutocomplete: !!value,
            adminCompanies: [],
        });
    };

    render() {
        const { showCopyCompaniesModal } = this.state;
        const {
            user,
            loading,
            userRoles,
            handleSubmit,
            initialValues,
            currentUser,
            isCurrentUser,
            roleSelected,
            change,
            errorCompanyIds,
        } = this.props;

        const disabled = isCurrentUser;
        const roleSelectedIsContractorsManager = roleSelected === String(UserRole.CONTRACTORS_MANAGER);
        const showRenderCurrentContractorFieldName = currentUser.role() !== UserRole.SUPERADMIN &&
            !roleSelectedIsContractorsManager;
        return (
            <Row>
                <Card loading={loading}>
                    <CardSimpleHeader
                        title={I18nUtils.tr(user ? 'TR_EDITAR_USUARIO' : 'TR_NUEVO_USUARIO')}
                    />
                    <CardBody>
                        <form onSubmit={handleSubmit(this.submit)}>
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_NOMBRE')}
                                    placeholder={I18nUtils.tr('TR_NOMBRE')}
                                    name={FORM.FIELDS.NAME}
                                    type={'text'}
                                    colWidth="col-md-6"
                                    component={this.renderField}
                                    disabled={disabled}
                                />
                                <Field
                                    label={I18nUtils.tr('TR_APELLIDO')}
                                    placeholder={I18nUtils.tr('TR_APELLIDO_S')}
                                    name={FORM.FIELDS.LAST_NAME}
                                    type={'text'}
                                    colWidth="col-md-6"
                                    component={this.renderField}
                                    disabled={disabled}
                                />
                            </Row>
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_EMAIL')}
                                    placeholder={I18nUtils.tr('TR_EMAIL')}
                                    name={FORM.FIELDS.EMAIL}
                                    type={'text'}
                                    colWidth="col-md-6"
                                    component={this.renderField}
                                    disabled={disabled}
                                />
                                <Field
                                    label={I18nUtils.tr('TR_CONTRASENA')}
                                    placeholder={I18nUtils.tr('TR_CONTRASENA')}
                                    name={FORM.FIELDS.PASSWORD}
                                    type={'password'}
                                    disabled={disabled || user}
                                    colWidth="col-md-6"
                                    component={this.renderField}
                                />
                            </Row>
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_ROL')}
                                    name={FORM.FIELDS.ROLE_ID}
                                    type={'selectSimple'}
                                    options={userRoles}
                                    colWidth="col-md-6"
                                    component={this.renderField}
                                    onChange={(event) => {
                                        // Hack para evitar que si se cambia a "Gestor de subcontratas" esté tu propia
                                        // empresa (contratista) seleccionada de antemano. Esto ocurre por cómo está
                                        // planteada esta pantalla y por redux forms.
                                        const selectedRol = Number(event.currentTarget.value);
                                        this.setState({ adminCompanies: [] });
                                        change(FORM.FIELDS.COMPANY_IDS, []);
                                        if ( UserRole.CONTRACTORS_MANAGER === selectedRol ) {
                                            change(FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTOR_COMPANY_TYPE, COMPANY_TYPE_CURRENT_CONTRACTOR);
                                            change(FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTED_COMPANY, currentUser.company().id);
                                        }
                                    }}
                                    disabled={disabled}
                                />
                                {showRenderCurrentContractorFieldName && this.renderCurrentContractorFieldName()}
                                {roleSelectedIsContractorsManager && this.renderSelectorCompanyToManage()}
                            </Row>
                            <Row>
                                <Field
                                    label={I18nUtils.tr('TR_ESTADO')}
                                    labelDisabled={I18nUtils.tr('TR_INACTIVO')}
                                    labelEnabled={I18nUtils.tr('TR_ACTIVO')}
                                    defaultChecked={true}
                                    name={FORM.FIELDS.ENABLED}
                                    checked={true}
                                    type="checkbox"
                                    colWidth="col-md-6"
                                    component={this.renderField}
                                    disabled={disabled}
                                />
                                {this.renderCompanyOrCompanies()}
                            </Row>
                            <Row>
                                {!disabled &&
                                    <Field
                                        label={I18nUtils.tr(user ? 'TR_EDITAR' : 'TR_CREAR').toUpperCase()}
                                        name={FORM.FIELDS.SUBMIT}
                                        type="submit"
                                        colWidth={'col-md-6 col-md-offset-6'}
                                        component={this.renderField}
                                        disabled={errorCompanyIds}
                                    />}
                            </Row>
                        </form>
                    </CardBody>
                </Card>
                <UserAdminCopyCompaniesModal
                    show={showCopyCompaniesModal}
                    title={I18nUtils.tr('TR_IMORTAR_EMPRESAS_DE_GESTOR')}
                    onHide={() => this.setState({ showCopyCompaniesModal: false })}
                    selectedUserId={initialValues && initialValues.id}
                    onAddCompanies={this.addCompanies}
                />
            </Row>
        );
    }

    addCompanies = (companies) => {
        const { formValues, change } = this.props;

        // Filtramos las empresas ya añadidas
        const companiesToAdd = companies.filter((company) => {
            if ( formValues && formValues.values && formValues.values.company_ids ) {
                return !( formValues.values.company_ids.indexOf(company.id) > -1 );
            } else {
                return true;
            }
        });

        // Modificmaos el estado para que funcionen los autocompletados
        this.setState({
            showCopyCompaniesModal: false,
            adminCompanies: [...this.state.adminCompanies, ...companiesToAdd],
        });

        // Modificamos el valor del formulario
        if ( formValues && formValues.values && formValues.values.company_ids ) {
            change(FORM.FIELDS.COMPANY_IDS, [...formValues.values.company_ids, ...companiesToAdd.map((company) => company.id)]);
        } else {
            change(FORM.FIELDS.COMPANY_IDS, companiesToAdd.map((company) => company.id));
        }
    };

    searchContractors = (term) => {
        this.props
            .contractorsActions
            .fetchContractorsBasic({
                term,
                page: undefined,
                only_active: true,
                only_inactive: false,
                show_only_deleted: false,
            });
    };

    handleSelectContractor = (selected) => {
        this.props.change(FORM.FIELDS.CONTRACTOR_ID, [...selected]);
    };

    submit = (values) => {
        const { currentUser, user } = this.props;

        if ( currentUser.isSuperAdmin() ) {
            if ( user ) this.updateUserAsSuperAdmin(values);
            else this.createUserAsSuperAdmin(values);
        } else {
            if ( user ) this.updateUserAsAdmin(values);
            else this.createUserAsAdmin(values);
        }
    };

    createUserAsAdmin = (values) => {
        const { adminCompanies } = this.state;
        const { currentUser } = this.props;
        const roleId = Number(values.role_id);

        values.disabled = !values.enabled;

        let companiesToManage = [];
        if ( roleId === UserRole.OUTSOURCES_MANAGER ) {
            companiesToManage = adminCompanies.map((company) => ( {
                id: undefined,
                role_id: roleId,
                company_id: company.id,
            } ));
        }

        values.user_roles = [{
            id: undefined,
            role_id: roleId,
            company_id: currentUser.myCompanyId(),
        },
            ...companiesToManage,
        ];

        if ( roleId === UserRole.CONTRACTORS_MANAGER && values.selectedCompany ) {
            values.user_roles = [{
                id: undefined,
                role_id: roleId,
                company_id: values.selectedCompany.id ? values.selectedCompany.id : values.selectedCompany,
            }];
        }

        values.selectedCompany = undefined;
        values.selectorCompanyType = undefined;

        this.props.userActions.addUser(values);
    };

    updateUserAsAdmin = (values) => {
        const { user, currentUser, initialValues } = this.props;
        const { adminCompanies } = this.state;
        values.disabled = !values.enabled;

        // Buscar el rol inicial del usuario respecto a current company
        const myRole = user.roles.find((role) => ( role.company && role.company.id === currentUser.myCompanyId() )) || user.roles[0];
        const initialRoleId = initialValues && initialValues.role_id;
        const selectedRoleId = values && values.role_id && Number(values.role_id);
        const updateUserRoleId = initialRoleId !== selectedRoleId;
        const selectedCompany = values.selectedCompany ? values.selectedCompany : currentUser.myCompanyId();
        const initialValuesSelectedCompany = initialValues.selectedCompany ? initialValues.selectedCompany : currentUser.myCompanyId();
        const selectedCompanyHasChanged = initialValuesSelectedCompany !== selectedCompany;

        // Si el rol del usuario ha cambiado, lo actualizaremos
        // El contratista puede ser de dos tipos: que pertenezca a la empresa o una subcontrata
        let updatedUserRole = {
            id: updateUserRoleId || ( !updateUserRoleId && selectedCompanyHasChanged ) ? undefined : myRole.id,
            role_id: Number(values.role_id),
            company_id: selectedCompany,
        };
        // Para los roles que no sean gestor contratista el company siempre va a ser el del currentUser
        if ( selectedRoleId !== UserRole.CONTRACTORS_MANAGER ) {
            updatedUserRole = {
                ...updatedUserRole,
                company_id: currentUser.myCompanyId(),
            };
        }

        const manageOtherCompanies = [];
        adminCompanies.forEach(company => {
            const existCompanyInUserRole = user.roles.find((role) => role.company.id === company.id);
            manageOtherCompanies.push({
                id: existCompanyInUserRole ? existCompanyInUserRole.id : undefined,
                role_id: Number(values.role_id),
                company_id: company.id,
            });
        });

        values.user_roles = [updatedUserRole, ...manageOtherCompanies];
        this.props.userActions.updateUser(values, updateUserRoleId);
    };

    createUserAsSuperAdmin = (values) => {
        const nextValues = this.createUpdateUserAsSuperAdmin(values);
        this.props.userActions.addUser(nextValues);
    };

    updateUserAsSuperAdmin = (values) => {
        const nextValues = this.createUpdateUserAsSuperAdmin(values);
        this.props.userActions.updateUser(nextValues);
    };

    createUpdateUserAsSuperAdmin = (values) => {
        const roleId = Number(values.role_id);
        const contractorId = roleId === UserRole.SUPERADMIN
            ? undefined
            : values.contractor_id[0]
                ? values.contractor_id[0].value
                : undefined;

        values.disabled = !values.enabled;
        values.contractor_id = contractorId;
        values.user_roles = [
            {
                id: undefined,
                role_id: roleId,
                contractor_id: contractorId,
            },
        ];

        return values;
    };
}

function validate(values) {
    const errors = {};

    if ( !values.name ) {
        errors.name = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    if ( !values.last_name ) {
        errors.last_name = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    if ( !values.email ) {
        errors.email = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    } else if ( !isEmailValid(values.email) ) {
        errors.email = I18nUtils.tr('TR_INTRODUCE_UN_EMAIL_VALIDO');
    }

    if ( !values.password ) {
        errors.password = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    if ( !values.role_id || values.role_id === -1 || values.role_id === '-1' ) {
        errors.role_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    } else {
        if ( String(values.role_id) === String(UserRole.OUTSOURCES_MANAGER) ) {
            if ( !values.company_ids || values.company_ids.length === 0 ||
                !values.company_ids.every(companyId => companyId > -1 || companyId === null)
            ) {
                errors.company_ids = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
            }
        } else {
            if ( String(values.role_id) === String(UserRole.ADMIN) ||
                String(values.role_id) === String(UserRole.SUPERADMIN) ) {
                if ( !values.contractor_id ) {
                    errors.contractor_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
                }
            }

            if ( String(values.role_id) === String(UserRole.CONTRACTORS_MANAGER) &&
                values.selectorCompanyType === COMPANY_TYPE_OUTSOURCE ) {
                if ( !values.selectedCompany ) {
                    errors.selectedCompany = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
                }
            }

            if ( !values.company_id || values.company_id === -1 || values.company_id === '-1' ) {
                errors.company_id = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
            }
        }
    }

    return errors;
}

UserFormCard = reduxForm({
    validate,
    form: FORM.NAME,
})(UserFormCard);

const mapStateToProps = (state, ownProps) => {
    const currentUser = CurrentUser.fromReduxState(state);
    const noAllowRoles = [];

    if ( currentUser.role() === UserRole.ADMIN ) {
        noAllowRoles.push(UserRole.SUPERADMIN);
    } else if ( currentUser.role() === UserRole.SUPERADMIN ) {
        noAllowRoles.push(
            UserRole.OUTSOURCES_MANAGER,
            UserRole.OUTSOURCES_VIEWER,
            UserRole.CONTRACTORS_MANAGER,
            UserRole.LISTERIA_MANAGER,
        );
    }

    const userRolesOptions = state.users.userRoles.map((role) => {
        return {
            value: role.id,
            name: role.name,
        };
    }).filter(role => !noAllowRoles.includes(role.value));

    let user = ownProps.user;
    let userContractorName = user && user.my_company ? user.my_company.name : null;
    if ( user ) {
        user.enabled = !ownProps.user.disabled;
        if ( ownProps.user.roles && ownProps.user.roles[0] ) {
            user.role_id = ownProps.user.roles[0].role.id;
            if ( ownProps.user.roles[0].company ) {
                user.company_id = ownProps.user.roles[0].company.id;
                user.company_ids = ownProps.user.roles
                                           .filter(role => user.my_company && role.company && role.company.id && role.company.id !== user.my_company.id)
                                           .map((role) => {
                                               if ( role.company ) {
                                                   return role.company.id;
                                               }
                                               return null;
                                           });
            }
        }
        if ( user.role_id === UserRole.CONTRACTORS_MANAGER ) {
            userContractorName = currentUser.contractor().name;
            const selectorCompanyType = user.roles[0].company.id === user.company.id ?
                COMPANY_TYPE_CURRENT_CONTRACTOR : COMPANY_TYPE_OUTSOURCE;
            user[FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTOR_COMPANY_TYPE] = selectorCompanyType;
            if ( selectorCompanyType === COMPANY_TYPE_CURRENT_CONTRACTOR ) {
                user[FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTED_COMPANY] = currentUser.company().id;
            } else {
                user[FORM.FIELDS.CONTRACTOR_ROLE_FIELDS.SELECTED_COMPANY] = user.roles[0].company;
            }

        }
    } else {
        user = {
            enabled: true,
            selectorCompanyType: COMPANY_TYPE_CURRENT_CONTRACTOR,
        };
    }

    const stateFormUserForm = state.form[FORM.NAME];
    const roleSelected =
        stateFormUserForm &&
        stateFormUserForm.values &&
        stateFormUserForm.values.role_id
            ? String(stateFormUserForm.values.role_id)
            : '';

    const errorCompanyIds =
        stateFormUserForm &&
        stateFormUserForm.values &&
        Number(stateFormUserForm.values.role_id) === UserRole.OUTSOURCES_MANAGER &&
        stateFormUserForm.syncErrors &&
        stateFormUserForm.syncErrors[FORM.FIELDS.COMPANY_IDS] &&
        stateFormUserForm.syncErrors[FORM.FIELDS.COMPANY_IDS].length !== 0;
    if ( errorCompanyIds ) {
        stateFormUserForm.syncErrors[FORM.FIELDS.COMPANY_IDS] = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');
    }

    return {
        initialValues: user,
        userRoles: userRolesOptions,
        contractors: state.contractors.contractors,
        loading: state.users.userLoading,
        formValues: stateFormUserForm,
        currentUser,
        userContractorName: userContractorName,
        isCurrentUser: currentUser.id() === ( user && user.id ),
        roleSelected: roleSelected,
        errorCompanyIds: errorCompanyIds,
    };
};

const mapDispatchToProps = dispatch => ( {
    userActions: bindActionCreators(userActions, dispatch),
    contractorsActions: bindActionCreators(contractorsActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(UserFormCard);

UserFormCard.propTypes = {
    user: PropTypes.shape({
        name: PropTypes.string.isRequired,
        last_name: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        password: PropTypes.string.isRequired,
    }),
};

UserFormCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/users/components/UserFormCard.jsx